import { useCampaignTFunction } from '@retail/campaign/i18n';
import { ToggleGroup, ToggleGroupOption } from '@retail/components';
import { useMemo } from 'react';
import { CampaignTypeOption } from './CampaignFilters';

interface Props {
  currentCampaignType: CampaignTypeOption;
  setCampaignType: (option: CampaignTypeOption) => void;
  options: CampaignTypeOption[];
}

export function CampaignTypeToggleGroup({ currentCampaignType, setCampaignType, options }: Props) {
  const t = useCampaignTFunction();

  const campaignTypeOptions: ToggleGroupOption<CampaignTypeOption>[] = useMemo(() => {
    const allOptions: ToggleGroupOption<CampaignTypeOption>[] = [
      { label: t('campaign.campaignOptions.all'), value: 'ALL' },
      { label: t('campaign.campaignOptions.central'), value: 'CENTRAL' },
      { label: t('campaign.campaignOptions.optional'), value: 'OPTIONAL' },
      { label: t('campaign.campaignOptions.supplier'), value: 'SUPPLIER' },
      { label: t('campaign.campaignOptions.local'), value: 'LOCAL' },
    ];
    return allOptions.filter(({ value }) => options.includes(value));
  }, [options, t]);

  return (
    <ToggleGroup
      variant="pill"
      label={t('campaign.columns.campaignType')}
      labelDirection="vertical"
      size="small"
      options={campaignTypeOptions}
      value={currentCampaignType}
      onChange={setCampaignType}
    />
  );
}
